import * as React from 'react';
import useWindowSize from './useWindowSize';

/**
 * React Hook that returns the current window size
 * and report updates from the 'resize' window event
 *
 * @typedef {useIsNarrowerThan} useIsNarrowerThan
 * @property {number} isNarrower Window width judgment...
 * @returns {isNarrower} A value representing whether the width is less than 768
 */

const useIsNarrowerThan = (width: number): boolean => {
    const { width: windowWidth } = useWindowSize();
    const [isNarrower, setIsNarrower] = React.useState(windowWidth < width);

    React.useEffect(() => {
        setIsNarrower(windowWidth < width);
    }, [windowWidth, width]);

    return isNarrower;
};

export default useIsNarrowerThan;
